export * from './lib/diff-price-int.module';
export * from './lib/diff-price.component';
